import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaRegLightbulb, FaExternalLinkAlt } from 'react-icons/fa';
import { ProductAdminRole } from '@/store/productAdminRole/slice';
import { Spinner } from '@/components/shared/Spinner';
import * as styles from './index.module.scss';

type Props = {
  roles: ProductAdminRole[];
  loading: boolean;
};

export const RoleList: React.FC<Props> = ({ roles, loading }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className={styles.loaderContainer}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.descriptions}>
        <FaRegLightbulb className={styles.lightbulbIcon} />
        <div className={styles.descriptionContent}>
          <div className={styles.mainDescription}>
            {t('text.role.list.description')}
          </div>
          <div className={styles.subDescription}>
            {t('text.role.list.multiOrgNotice')}
          </div>
          <div className={styles.subDescription}>
            {t('text.role.list.serviceInquiryNotice')}
          </div>
          <ul className={styles.inquiryList}>
            <li>
              <a
                href={t('text.role.list.embaSolutionUrl')}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('text.role.list.embaSolutionLabel')}
              </a>
            </li>
            <li>
              <a
                href={t('text.role.list.schoolUrl')}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('text.role.list.schoolLabel')}
              </a>
            </li>
            <li>{t('text.role.list.gmapNotice')}</li>
          </ul>
        </div>
      </div>

      <div className={styles.productList}>
        {roles.map(({ productName, role, helpUrl }, index) => {
          return (
            <div key={index} className={styles.productItem}>
              <div className={styles.productInfo}>
                <span className={styles.productName}>{productName}</span>
                <span className={styles.roleText}>{role}</span>
              </div>
              <a
                href={helpUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.productLink}
              >
                {t('text.role.list.roleAbout')}
                <FaExternalLinkAlt className={styles.externalIcon} />
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};
